module.exports = {
    defaultLanguage: 'es',
    scssVariables: './src/styles/bago2023',
    profileColor: {saturation: 80, brighness: 50},
    favicon: 'bagofavicon.ico',
    defaultPassword: 'default'
}